import { jsxs as _, jsx as a } from "react/jsx-runtime";
import { R as w, I as N } from "../../../index-DY4xfaRl.js";
import { c as d } from "../../../clsx-OuTLNxxd.js";
import { useRef as v, useEffect as y } from "react";
import { B as E } from "../../../button.types-khNMDxMV.js";
import "../../../icon-BnqXyiyH.js";
import "../icon/iconsList.js";
import { Title as S } from "../title/title.js";
const e = {
  "panel-container": "_panel-container_11fx7_29",
  "with-progress-bar": "_with-progress-bar_11fx7_41",
  "title-container": "_title-container_11fx7_44",
  "with-picture-mobile": "_with-picture-mobile_11fx7_47",
  "is-warning": "_is-warning_11fx7_50",
  "with-picture": "_with-picture_11fx7_47",
  "panel-title": "_panel-title_11fx7_73",
  "panel-description": "_panel-description_11fx7_77",
  "width-image": "_width-image_11fx7_90",
  "panel-button": "_panel-button_11fx7_97",
  "panel-progress-bar-container": "_panel-progress-bar-container_11fx7_108",
  "panel-progress-bar": "_panel-progress-bar_11fx7_108",
  "panel-progress-bar-indicator": "_panel-progress-bar-indicator_11fx7_126",
  "panel-bg-illustration": "_panel-bg-illustration_11fx7_141",
  "panel-illustration": "_panel-illustration_11fx7_142",
  "dialog-overlay-show": "_dialog-overlay-show_11fx7_1",
  "dialog-content-show": "_dialog-content-show_11fx7_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_11fx7_1"
}, T = {
  warning: "is-warning"
};
function q({
  title: o,
  onClick: s,
  actionText: g,
  percentage: n,
  pictureUrl: i,
  bgPictureUrl: r,
  displayPictureOnMobile: h = !0,
  className: u,
  status: c,
  children: b
}) {
  const p = v(null);
  return y(() => {
    const t = (x) => {
      var m;
      if (x.target.tagName !== "BUTTON") {
        const f = (m = p.current) == null ? void 0 : m.querySelector("button");
        f && f.click();
      }
    }, l = p.current;
    return l && l.addEventListener("click", t), () => {
      l && l.removeEventListener("click", t);
    };
  }, []), /* @__PURE__ */ _(
    "div",
    {
      ref: p,
      className: d(
        e["panel-container"],
        n && e["with-progress-bar"],
        (r || i) && (h ? e["with-picture-mobile"] : e["with-picture"]),
        c && e[T[c]],
        u
      ),
      children: [
        /* @__PURE__ */ a("div", { className: e["title-container"], children: /* @__PURE__ */ a(S, { className: e["panel-title"], level: 3, children: o }) }),
        /* @__PURE__ */ a("div", { className: d(e["panel-description"], (r || i) && e["width-image"]), children: b }),
        /* @__PURE__ */ a(
          E,
          {
            onClick: (t) => {
              s == null || s(), t.stopPropagation();
            },
            color: "primary",
            className: e["panel-button"],
            size: "medium",
            children: g
          }
        ),
        n !== void 0 && /* @__PURE__ */ _("div", { className: e["panel-progress-bar-container"], children: [
          /* @__PURE__ */ a(w, { className: e["panel-progress-bar"], "aria-label": "progress-bar-panel", children: /* @__PURE__ */ a(
            N,
            {
              className: e["panel-progress-bar-indicator"],
              style: { transform: `translateX(-${100 - n}%)` }
            }
          ) }),
          /* @__PURE__ */ _("span", { children: [
            n,
            "%"
          ] })
        ] }),
        r && /* @__PURE__ */ a("img", { className: e["panel-bg-illustration"], alt: o, src: r }),
        i && /* @__PURE__ */ a("img", { className: e["panel-illustration"], alt: o, src: i })
      ]
    }
  );
}
export {
  q as Panel
};
